import { Input, Spin, message } from "antd";
import React, { useContext, useState } from "react";
import { getBarcodeWoNHd, getWoNAllPcidDetail } from "../../../services/api";

import CustomTable from "../../../components/antdCustom/CustomTable";
import Title from "../../../components/Custom/Title";
import { IconExcel } from "../../../components/Icon/index";
import { MySubtitleH4 } from "../../../styled/publicTag.js";
import { DataContext } from "../index";

const innerWidth = window.innerWidth;

const HD = () => {
  const scrollY = 300;

  // 頁面載入狀態
  const [is_spinning, set_is_spinning] = useState(false);

  // 表格載入狀態
  const [s_isTableLoading, set_s_isTableLoading] = useState(false);

  // 表頭資料
  const [s_tableData, set_s_tableData] = useState([]);

  // 要搜尋的文字
  const [s_searchValue, set_s_searchValue] = useState("");

  const { c_lightData, set_c_lightData } = useContext(DataContext); // 表身要顯示資料的key

  // 分頁資訊
  const [pageInfo, setPageInfo] = useState({
    currentPage: 0,
    pageItemNumber: 10,
    totalItems: 0,
    pageSize: 10,
  });

  // 搜尋
  const onSearch = (value) => {
    call_getBarcodeWoNHd(value);
    set_c_lightData({});
  };

  // 輸入搜尋文字
  const handleChange = (value) => {
    console.log(value);
    set_s_searchValue(value);
  };

  // 取得所有表頭資料
  const call_getBarcodeWoNHd = async (searchValue = s_searchValue) => {
    set_s_isTableLoading(true);
    try {
      const queryValue = searchValue || "";
      const res =
        queryValue === ""
          ? await getBarcodeWoNHd()
          : await getBarcodeWoNHd({ woN: queryValue });

      if (res.status) {
        console.log(res.data);
        const data = res.data || [];
        const tmpData = data.map((item, index) => {
          return {
            ...item,
            key: index,
          };
        });
        message.success(res.msg);
        set_s_tableData(tmpData);
        setPageInfo((prev) => ({
          ...prev,
          totalItems: tmpData.length,
        }));
      } else {
        message.error(res.msg);
        set_s_tableData([]);
        setPageInfo((prev) => ({
          ...prev,
          totalItems: 0,
        }));
      }
    } catch (e) {
      console.log("---------- api getBarcodeWoNHd error ----------");
      console.log(e);
    } finally {
      set_s_isTableLoading(false);
    }
  };

  // 點擊 Excel icon 後取得後端 Excel 下載連結
  const handleDownloadExcel = async () => {
    if (Object.keys(c_lightData).length === 0) return;

    set_is_spinning(true);
    try {
      const res = await getWoNAllPcidDetail({ woN: c_lightData.woN });
      console.log("excel res = ", res);

      if (res.status === true && res.data) {
        message.success(res.msg);
        window.open(res.data, "_blank", "noopener,noreferrer");
      } else {
        message.error(res.msg);
      }
    } catch (e) {
      console.log("---------- api getWoNAllPcidDetail error ----------");
      console.log(e);
    } finally {
      set_is_spinning(false);
    }
  };

  const tableColumns = [
    {
      title: "工單號",
      dataIndex: "woN",
      align: "center",
      width: innerWidth <= 1440 ? `${200}px` : `${220}px`,
    },
    {
      title: "產品型號",
      dataIndex: "dim1",
      align: "center",
      width: innerWidth <= 1440 ? `${200}px` : `${200}px`,
    },
    {
      title: "生產序號起",
      dataIndex: "pcidstart",
      align: "center",
      width: innerWidth <= 1440 ? `${120}px` : `${200}px`,
    },
    {
      title: "生產序號末",
      dataIndex: "pcidend",
      align: "center",
      width: innerWidth <= 1440 ? `${150}px` : `${250}px`,
    },
    {
      title: "預計產量",
      dataIndex: "planqty",
      align: "center",
      width: innerWidth <= 1440 ? `${80}px` : `${100}px`,
    },
    {
      title: "生產數量",
      dataIndex: "okC",
      align: "center",
      width: innerWidth <= 1440 ? `${80}px` : `${100}px`,
    },
    {
      title: "生產開始",
      dataIndex: "startTstr",
      align: "center",
      width: innerWidth <= 1440 ? `${80}px` : `${150}px`,
    },
    {
      title: "生產結束",
      dataIndex: "closeTstr",
      align: "center",
      width: innerWidth <= 1440 ? `${80}px` : `${150}px`,
    },
  ];

  return (
    <Spin size="large" spinning={is_spinning}>
      <Title title="工單序號查詢">
        <div className="flex-r">
          <Input.Search
            className="Input"
            size="large"
            placeholder="請輸入生產序號"
            onChange={(e) => handleChange(e.target.value)}
            onSearch={onSearch}
            enterButton
          />
          {Object.keys(c_lightData).length > 0 && (
            <span style={{ height: "38px", cursor: "pointer" }}>
              <IconExcel
                style={{
                  width: "30px",
                  height: "38px",
                  marginLeft: "10px",
                  marginRight: "5px",
                }}
                onClick={handleDownloadExcel}
              />
            </span>
          )}
        </div>
      </Title>

      <CustomTable
        loading={s_isTableLoading}
        size={innerWidth <= 1440 ? "16px" : null} // 表頭字體大小
        scroll={{ x: "max-content", y: scrollY }}
        columns={tableColumns}
        dataSource={s_tableData.map((item, index) => {
          return { ...item, key: index };
        })}
        rowClassName={(record, index) => {
          const rowKey = record.pcidstart + record.pcidend;
          const dataKey = c_lightData.pcidstart + c_lightData.pcidend;
          const clickRowStyle = rowKey === dataKey ? "clickRowStyle" : "";
          return index % 2 === 1
            ? `light ${clickRowStyle}`
            : `dark ${clickRowStyle}`;
        }}
        onRow={(record) => {
          return {
            onClick: () => {
              const rowKey = record.pcidstart + record.pcidend;
              const dataKey = c_lightData.pcidstart + c_lightData.pcidend;
              if (rowKey === dataKey) {
                set_c_lightData({});
              } else {
                set_c_lightData(record);
              }
            },
          };
        }}
        pagination={{
          defaultCurrent: 1,
          total: pageInfo.totalItems,
          // current: abcBoardConfig.page,
          showSizeChanger: true,
          pageSize: pageInfo.pageSize,
          pageSizeOptions: ["10", "20", "30"],
          onChange: (current, size) => {
            setPageInfo({
              ...pageInfo,
              pageSize: size,
            });
          },
          showTotal: (total, range) => (
            <MySubtitleH4>
              共 {total} 項 ， 正在顯示第{range[0]}到{range[1]}項
            </MySubtitleH4>
          ),
        }}
      />
    </Spin>
  );
};

export default HD;
